import Label from './label.vue'
import ArticleLists from './articleLists.vue'
import Message from './message.vue'
import Art from './art.vue'
import Protocol from './protocol.vue'
export default {
	Label,
	ArticleLists,
	Message,
	Art,
	Protocol
}



// WEBPACK FOOTER //
// ./src/views/content/index.js